// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/imputation_policy_model.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/imputation_policy_model.proto.
 */
export const file_bffuser_v1_imputation_policy_model: GenFile = /*@__PURE__*/
  fileDesc("CihiZmZ1c2VyL3YxL2ltcHV0YXRpb25fcG9saWN5X21vZGVsLnByb3RvEgpiZmZ1c2VyLnYxItcBChBJbXB1dGF0aW9uUG9saWN5Ej8KDWRlbWFuZF9tZXRob2QYASABKA4yHC5iZmZ1c2VyLnYxLkltcHV0YXRpb25NZXRob2RCCrpIB4IBBBABIAASUgoXZ2VuZXJhdGlvbl9tZXRob2Rfb3JkZXIYAiADKA4yHC5iZmZ1c2VyLnYxLkltcHV0YXRpb25NZXRob2RCE7pIEJIBDQgCEAIiB4IBBBABIAASLgoKdXBkYXRlZF9hdBgDIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXAqowEKEEltcHV0YXRpb25NZXRob2QSIQodSU1QVVRBVElPTl9NRVRIT0RfVU5TUEVDSUZJRUQQABIfChtJTVBVVEFUSU9OX01FVEhPRF9QUkVWX1RJTUUQARIpCiVJTVBVVEFUSU9OX01FVEhPRF9TQU1FX1dFRUtEQVlfUkVDRU5UEAISIAocSU1QVVRBVElPTl9NRVRIT0RfUExBTl9WQUxVRRADQkBaPmdpdGh1Yi5jb20vZW5lY2hhaW4vZWJhbGFuY2UvZ28vZ2VuL3Byb3RvL2JmZnVzZXIvdjE7YmZmdXNlcnYxYgZwcm90bzM", [file_buf_validate_validate, file_google_protobuf_timestamp]);

/**
 * ImputationPolicy holds the organization-wide imputation method selection
 * (欠損補完設定 screen).
 * Mirrors internalapi.v1.ImputationPolicy; the BFF handler converts between
 * them.
 *
 * Usage in Update: the strict protovalidate rules below require the client to
 * populate every field on every UpdateImputationPolicy call. The companion
 * update_mask acts as a *change marker*, not a partial-payload selector —
 * same policy as PersonalSettings (setting_model.proto) and TODO(#556).
 *
 * @generated from message bffuser.v1.ImputationPolicy
 */
export type ImputationPolicy = Message<"bffuser.v1.ImputationPolicy"> & {
  /**
   * Demand-side method (spec §1, radio OR-choice).
   *
   * @generated from field: bffuser.v1.ImputationMethod demand_method = 1;
   */
  demandMethod: ImputationMethod;

  /**
   * Generation-side fallback chain (spec §2): exactly 2 entries, applied in
   * array order (1st method first, 2nd on failure). Specifying this field in
   * update_mask replaces the entire array.
   *
   * @generated from field: repeated bffuser.v1.ImputationMethod generation_method_order = 2;
   */
  generationMethodOrder: ImputationMethod[];

  /**
   * Last-updated timestamp. Populated in Get responses only when a saved row
   * exists (unset while the spec defaults are being returned); ignored in
   * Update requests.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 3;
   */
  updatedAt?: Timestamp;
};

/**
 * Describes the message bffuser.v1.ImputationPolicy.
 * Use `create(ImputationPolicySchema)` to create a new message.
 */
export const ImputationPolicySchema: GenMessage<ImputationPolicy> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_imputation_policy_model, 0);

/**
 * ImputationMethod is a 欠損補完 (missing-data imputation) method
 * (docs/specs/demand/missing-data-interpolation.md §1 / §2).
 * Mirrors internalapi.v1.ImputationMethod; the BFF handler converts between
 * them.
 *
 * @generated from enum bffuser.v1.ImputationMethod
 */
export enum ImputationMethod {
  /**
   * @generated from enum value: IMPUTATION_METHOD_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * 直前コマ引用 (both sides).
   *
   * @generated from enum value: IMPUTATION_METHOD_PREV_TIME = 1;
   */
  PREV_TIME = 1,

  /**
   * 同曜日種別 直近実績 (demand side).
   *
   * @generated from enum value: IMPUTATION_METHOD_SAME_WEEKDAY_RECENT = 2;
   */
  SAME_WEEKDAY_RECENT = 2,

  /**
   * 計画値代入 (generation side).
   *
   * @generated from enum value: IMPUTATION_METHOD_PLAN_VALUE = 3;
   */
  PLAN_VALUE = 3,
}

/**
 * Describes the enum bffuser.v1.ImputationMethod.
 */
export const ImputationMethodSchema: GenEnum<ImputationMethod> = /*@__PURE__*/
  enumDesc(file_bffuser_v1_imputation_policy_model, 0);

